import styled from 'styled-components'

export const Container = styled.div`
    textarea {
        padding: 5px 0 0 0;
        line-height: 20px;
    }
`
